<template>
  <div id="app">
    <MapTool></MapTool>
  </div>
</template>

<script>
import MapTool from "./packages/map-tool";

export default {
  name: "App",
  components: {
    MapTool
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue